import "./Modal.scss";
import ReactDom from "react-dom";
import { useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { ModalThankYou } from "../ModalThankYou";
import { ModalError } from "../ModalError";
import { Spinner } from "../Spinner";
import { ModalDHLError } from "../ModalDHLError";

export const Modal = ({ open, onClose }) => {
  const [ModalThankYouIsOpen, setModalThankYouIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [uploadedFile, setUploadedFile] = useState("");
  const [uploadedCertification, setUploadedCertification] = useState("");

  const {
    getValues,
    formState: { errors },
    handleSubmit,
    watch,
  } = useFormContext();
  const values = getValues();

  const { ...file } = watch("narzedzia[0].skandowodu");
  const { ...certificationFile } = watch("narzedzia[0].skancertyfikatu");

  async function fetchForm(data) {
    setIsLoading(true);
    setIsError(false);
    setErrorMessage("");
    try {
      const response = await fetch("https://service.erpatech.de/api/new_form", {
        method: "post",
        headers: {
          Authorization: "Token 4695f36f199000bff9859143974a66a20133753f",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        const errorData = await response.json();
        console.log("ERRRRROR", errorData);
        throw errorData;
      }
      const dataForm = await response.json();

      console.log("Success!!!!!!!!", dataForm);

      setIsLoading(false);
      setModalThankYouIsOpen(true);
    } catch (error) {
      console.log("ERRRRROR", error);
      setIsLoading(false);
      setIsError(true);
      setErrorMessage(error.response);
    }
  }

  useEffect(() => {
    const reader = new FileReader();

    if (file && file?.[0]?.type) {
      reader.readAsDataURL(file[0]);

      reader.onload = function (e) {
        setUploadedFile(reader.result);
      };
    }
  }, [file]);

  useEffect(() => {
    const certificationReader = new FileReader();

    if (certificationFile && certificationFile?.[0]?.type) {
      certificationReader.readAsDataURL(certificationFile[0]);

      certificationReader.onload = function (e) {
        setUploadedCertification(certificationReader.result);
      };
    }
  }, [certificationFile]);

  const onSubmit = (data) => {
    console.log(JSON.stringify(data));
    const submittedData = {
      ...data,
      narzedzia: [
        {
          ...data.narzedzia[0],
          skandowodu: uploadedFile,
          skancertyfikatu: uploadedCertification,
        },
      ],
    };
    fetchForm(submittedData);
  };

  if (!open) return null;

  return ReactDom.createPortal(
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="Modal">
          <div className="Modal__title">
            <div className="ModalError__closeBtnContainer">
              <div
                className="ModalError__closeBtnContainer__closeBtn"
                onClick={onClose}
              ></div>
            </div>
            <div className="Modal__title__text">
              Zusammenfassung der Meldung
            </div>
          </div>
          <div className="Modal__summary">
            <div className="Modal__summary__userDetails">
              <div className="summaryTitle">
                <img src="/img/person_icon.svg" alt="person icon" />
                <h2 id="UserDetails">der Anmelder</h2>
              </div>
              <div className="Modal__summary__userDetails__info">
                <div className="Modal__summary__userDetails__info--data">
                  <p>Vor- und Nachname:</p>
                  <p className="fromUser">
                    {values.imie} {values.nazwisko}
                  </p>
                </div>

                {window.innerWidth < 1366 && values.nip ? (
                  <div className="Modal__summary__userDetails__info--data">
                    <p>USt-IdNr.:</p>
                    <p className="fromUser">{values.nip}</p>
                  </div>
                ) : null}

                {window.innerWidth < 1366 && values.nazwafirmy ? (
                  <div className="Modal__summary__userDetails__info--data">
                    <p>Firmenname</p>
                    <p className="fromUser">{values.nazwafirmy}</p>
                  </div>
                ) : null}

                <div className="Modal__summary__userDetails__info--data">
                  <p>Adresse:</p>
                  <p className="fromUser">
                    {values.nadawcaulica} {values.nadawcanrdomu}{" "}
                    {values.nadawcanrlokalu}
                  </p>
                </div>
                <div className="Modal__summary__userDetails__info--data">
                  <p>Ort:</p>
                  <p className="fromUser">
                    {values.nadawcakodpocztowy} {values.nadawcamiasto}
                  </p>
                </div>
                <div className="Modal__summary__userDetails__info--data">
                  <p>Telefon:</p>
                  <p className="fromUser">{values.tel}</p>
                </div>
                <div className="Modal__summary__userDetails__info--data">
                  <p>E-mail</p>
                  <p className="fromUser">{values.email}</p>
                </div>

                {window.innerWidth >= 1366 && values.nip ? (
                  <div className="Modal__summary__userDetails__info--data">
                    <p>Steuernummer:</p>
                    <p className="fromUser">{values.nip}</p>
                  </div>
                ) : null}
                {window.innerWidth >= 1366 && values.nazwafirmy ? (
                  <div className="Modal__summary__userDetails__info--data">
                    <p>Firmenname:</p>
                    <p className="fromUser">{values.nazwafirmy}</p>
                  </div>
                ) : null}
              </div>
            </div>

            <div className="Modal__summary__toolsSummary">
              <div className="summaryTitle">
                <img src="/img/drill_icon.svg" alt="drill icon" />
                <h2>Werkzeug</h2>
              </div>
              <div className="Modal__summary__toolsSummary__container">
                <div className="Modal__summary__toolsSummary__container__info--data">
                  <p>Modell:</p>
                  <p className="fromUser">{values.narzedzia[0].modeltowaru}</p>
                </div>
                {values.narzedzia[0].datazakupu ? (
                  <div className="Modal__summary__toolsSummary__container__info--data">
                    <p>Kaufdatum:</p>
                    <p className="fromUser">{values.narzedzia[0].datazakupu}</p>
                  </div>
                ) : null}

                {values.narzedzia[0].nrseryjny ? (
                  <div className="Modal__summary__toolsSummary__container__info--data">
                    <p>Seriennummer:</p>
                    <p className="fromUser">{values.narzedzia[0].nrseryjny}</p>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="Modal__summary__deliverySummary">
              <div className="summaryTitle">
                <img src="/img/box_icon.svg" alt="person icon" />
                <h2>Paketabholung</h2>
              </div>
              <div className="Modal__summary__deliverySummary__container">
                {values.typprzesylki ? (
                  <div className="Modal__summary__deliverySummary__container__data">
                    <p>Spediteur:</p>
                    <p className="fromUser">
                      {watch("typprzesylki") === ("DPD" || "DHL")
                        ? values.typprzesylki
                        : values.typprzesylki === "Inpost"
                        ? "Inpost"
                        : values.typprzesylki === "dpd ps"
                        ? "DPD"
                        : "DHL"}
                    </p>
                  </div>
                ) : null}

                {values.dzien_odbioru ? (
                  <div className="Modal__summary__deliverySummary__container__data">
                    <p>Abholdatum:</p>
                    <p className="fromUser">{values.dzien_odbioru}</p>
                  </div>
                ) : null}

                <div className="Modal__summary__deliverySummary__container__data">
                  <p>Verpackungskategorie:</p>
                  <p className="fromUser">{values.rozmiar_paczki}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="confirmationButtonBox">
            <button
              className="confirmationButtonBox__button"
              type="submit"
              onClick={fetchForm}
            >
              Bestätigen
            </button>
          </div>
        </div>
        <div className="Modal__overlay"></div>

        {ModalThankYouIsOpen && (
          <ModalThankYou openThankYou={ModalThankYouIsOpen} />
        )}
        {isError && !errorMessage && (
          <ModalError isError={isError} onClose={() => setIsError(false)} message={errorMessage} />
        )}
        {isError && errorMessage && <ModalDHLError message={errorMessage} onClose={() => setIsError(false)} />}

        {isLoading && <Spinner isLoading={isLoading} />}
        {/* <Spinner /> */}
      </form>
    </>,
    document.getElementById("portal")
  );
};
